// extracted by mini-css-extract-plugin
module.exports = {"container":"title-with-body__container___Au9VK"};